import { PAGE_ACCESS } from "@/lib/pageAccess";

// Fiecare item poate avea `module` — dacă modulul nu are licență activă, se ascunde. Cine vede un item: lib/pageAccess.js
// (aceleași reguli ca la rute); itemele fără intrare acolo se arată după `perm`.
export const NAV_GROUPS = [
  { title: "Dashboard", items: [
    { to: "/", label: "Panou de control", icon: "▤", perm: ["dashboard.view"] },
    { to: "/my-account", label: "Contul meu", icon: "◉", perm: ["my_account.profile_view"] },
    { to: "/notifications", label: "Notificări", icon: "◇", perm: ["notifications.view"] },
    { to: "/planco/approvals", label: "Documente în așteptare", icon: "✓", module: "planco" },
    { to: "/planco/calendar", label: "Calendar Programări", icon: "▦", module: "planco" },
    { to: "/planco/archive", label: "Arhivă Programări", icon: "▨", module: "planco" },
  ]},
  { title: "Parametrii", items: [
    { to: "/admin/users", label: "Utilizatori și Roluri", icon: "◑" },
    { to: "/admin/access", label: "Acces", icon: "◈" },
    { to: "/admin/license", label: "Licență", icon: "⚿", clientInstallOnly: true },
    { to: "/admin/security", label: "Securitate", icon: "⛨" },
    { to: "/admin/gdpr", label: "GDPR", icon: "⚖" },
    { to: "/admin/smtp", label: "Email (SMTP)", icon: "✉" },
    { to: "/admin/appearance", label: "Aspect interfață", icon: "◐" },
    { to: "/admin/audit", label: "Jurnal de audit", icon: "◕" },
  ]},
  { title: "Configurare Angajator", items: [
    { to: "/mdm/employer", label: "Angajator (+ Puncte de lucru)", icon: "⌂" },
    { to: "/mdm/structure", label: "Structură Organizatorică", icon: "⌘" },
    { to: "/admin/persons", label: "Angajați", icon: "◐" },
    { to: "/mdm/employments", label: "Rapoarte de Muncă", icon: "◧" },
    { to: "/mdm/nomenclatoare", label: "Nomenclatoare", icon: "▥" },
  ]},
  { title: "PlanCo - Programare concedii", items: [
    { to: "/planco/planning", label: "Programare Concediu", icon: "✎", module: "planco" },
    { to: "/planco/campaigns", label: "Campanii de programare", icon: "◆", module: "planco" },
    { to: "/planco/delegations", label: "Delegare Aprobări", icon: "⇄", module: "planco" },
    { to: "/planco/reports", label: "Rapoarte", icon: "◈", module: "planco" },
    { to: "/mdm/signatures", label: "Semnături Autorizate", icon: "✍", module: "planco" },
    { to: "/planco/holidays", label: "Sărbători Legale", icon: "★", module: "planco" },
    { to: "/planco/planning-year", label: "Anul de programare", icon: "◷", module: "planco" },
  ]},
  { title: "Dosar Electronic Angajat", items: [
    { to: "/employee-files", label: "Dosar Electronic", icon: "🗂", module: "employee_files" },
    { to: "/employee-files/categories", label: "Categorii Documente", icon: "▥", module: "employee_files" },
  ]},
  { title: "Stat de Funcții", items: [
    { to: "/stat-functii", label: "Posturi", icon: "📋", module: "stat_functii" },
    { to: "/stat-functii/atributii", label: "Biblioteca de atribuții", icon: "▤", module: "stat_functii" },
    { to: "/stat-functii/categorii", label: "Categorii de post", icon: "▥", module: "stat_functii" },
  ]},
  { title: "Stat de Funcții Didactic", items: [
    { to: "/stat-didactic/ani", label: "Ani universitari și parametri", icon: "◷", module: "stat_didactic" },
    { to: "/stat-didactic/programe", label: "Programe de studii", icon: "◧", module: "stat_didactic" },
    { to: "/stat-didactic/planuri", label: "Planuri de învățământ", icon: "▦", module: "stat_didactic" },
    { to: "/stat-didactic/formatiuni", label: "Formațiuni de studii", icon: "◫", module: "stat_didactic" },
    { to: "/stat-didactic/nota", label: "Nota de comandă", icon: "▤", module: "stat_didactic" },
    { to: "/stat-didactic/nota/atribuire", label: "Atribuire către catedre", icon: "⇉", module: "stat_didactic" },
    { to: "/stat-didactic/nota/lucrari", label: "Lucrări îndrumate", icon: "✎", module: "stat_didactic" },
    { to: "/stat-didactic/stat", label: "Statul pe departament", icon: "▥", module: "stat_didactic" },
    { to: "/stat-didactic/plata-ora", label: "Plata cu ora", icon: "◔", module: "stat_didactic" },
    { to: "/stat-didactic/plata-ora/pontaj", label: "Pontaj plata cu ora", icon: "◴", module: "stat_didactic" },
    { to: "/stat-didactic/plata-ora/salarizare", label: "Calcul pentru Salarizare", icon: "◵", module: "stat_didactic" },
    { to: "/stat-didactic/setari", label: "Setări", icon: "⚙", module: "stat_didactic" },
  ]},
  { title: "Pontaj Proiecte", items: [
    { to: "/timeentries", label: "Pontaj", icon: "⏱", module: "timeentries" },
  ]},
];

// Instalare de client neactivată: Adminul vede strict activarea licenței (vezi core/activation_gate.py).
export const NAV_GROUPS_ACTIVATION = [
  { title: "Parametrii", items: [
    { to: "/admin/license", label: "Licență", icon: "⚿", clientInstallOnly: true },
  ]},
];

// Superadmin e unic (al platformei, nu al clientului) — vede STRICT acest
// meniu, nimic din restul aplicației (nu Dashboard, nu Configurare Angajator
// etc.), indiferent ce alte roluri ar avea incidental.
export const NAV_GROUPS_SUPERADMIN = [
  { title: "Superadmin", items: [
    { to: "/admin/licenses", label: "Emitere Licențe", icon: "◉" },
    { to: "/admin/updates", label: "Actualizări", icon: "⇪" },
    { to: "/admin/clients", label: "Lista Angajatori/Clienți", icon: "☰" },
    { to: "/admin/licensed-employers", label: "Angajatori Licențiați", icon: "⌂" },
    { to: "/admin/licensing-audit", label: "Jurnal licențiere", icon: "☷" },
    { to: "/notifications", label: "Notificări", icon: "◇" },
    { to: "/admin/smtp", label: "Email (SMTP)", icon: "✉" },
    { to: "/admin/audit", label: "Jurnal de audit", icon: "◕" },
  ]},
];


// Pictogramă și cheie de adresă pentru fiecare grup (pagina de modul: /m/:cheie)
export const GROUP_META = {
  "Dashboard": { key: "start", icon: "home" },
  "Parametrii": { key: "parametrii", icon: "gearUser" },
  "Configurare Angajator": { key: "angajator", icon: "building" },
  "PlanCo - Programare concedii": { key: "planco", icon: "calendar" },
  "Dosar Electronic Angajat": { key: "dosar", icon: "folder" },
  "Stat de Funcții": { key: "stat-functii", icon: "clipboard" },
  "Stat de Funcții Didactic": { key: "stat-didactic", icon: "clipboard" },
  "Pontaj Proiecte": { key: "pontaj", icon: "clock" },
  "Superadmin": { key: "superadmin", icon: "shield" },
};
export const groupKey = (g) => (GROUP_META[g.title] || { key: g.title.toLowerCase().replace(/\W+/g, "-") }).key;
export const groupIcon = (g) => (GROUP_META[g.title] || { icon: "list" }).icon;

/** Grupurile de meniu pe care utilizatorul curent le vede (aceleași reguli: rol/permisiuni, licență de modul, instalare de client).
 *  Aspectele Fiord și Purple (orice `theme` în afară de „navy”) mută paginile PlanCo din „Dashboard” în grupul PlanCo și duce „Panou de control” la /panou
 *  (la rădăcină stă pagina de start cu plăci); aspectul navy păstrează structura originală. */
export function visibleGroups({ hasRole, hasModule, allowed, activationRequired, isClientInstall, theme = "purple" }) {
  const groups = hasRole("superadmin") ? NAV_GROUPS_SUPERADMIN : activationRequired ? NAV_GROUPS_ACTIVATION : NAV_GROUPS;
  let out = groups.map(g => ({
    ...g,
    items: g.items.filter(it =>
      (hasRole("superadmin") || allowed(...(PAGE_ACCESS[it.to] ? [PAGE_ACCESS[it.to].roles, PAGE_ACCESS[it.to].perm] : [null, it.perm]))) &&
      (!it.clientInstallOnly || isClientInstall) &&
      (!it.module || hasModule(it.module))),
  }));
  if (theme !== "navy") {
    const dash = out.find(g => g.title === "Dashboard"), planco = out.find(g => g.title.startsWith("PlanCo"));
    if (dash && planco) {
      const moving = dash.items.filter(i => i.module === "planco");
      dash.items = dash.items.filter(i => i.module !== "planco").map(i => (i.to === "/" ? { ...i, to: "/panou" } : i));
      planco.items = [...planco.items.slice(0, 1), ...moving, ...planco.items.slice(1)];
    } else if (dash) dash.items = dash.items.map(i => (i.to === "/" ? { ...i, to: "/panou" } : i));
  }
  return out.filter(g => g.items.length > 0);
}
